
import { EventsEnum } from '@/lib/enum/events';
import { openFreshdeskWidget } from '@/plugins/freshdesk';
import store from '@/store';

export default {
  name: 'FreshdeskLauncher',

  data() {
    return {
      showLauncher: false,
    };
  },

  computed: {
    currentCompany: () => store.getters.currentCompany,
    loggedInEmployee: () => store.getters.loggedInEmployee,
  },

  mounted() {
    this.showLauncher = true;

    this.$root.$on(
      EventsEnum.ToggleFreshdeskLauncher,
      this.toggleFreshdeskLauncher,
    );
  },

  beforeDestroy() {
    this.$root.$off(
      EventsEnum.ToggleFreshdeskLauncher,
      this.toggleFreshdeskLauncher,
    );
  },

  methods: {
    openFreshdeskWidget,
    toggleFreshdeskLauncher(v: Boolean | null = null) {
      this.showLauncher = v || !this.showLauncher;
    },
  },
};
